import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { PersonalDetailsService } from './personal-details.service';
@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
})
export class PersonalDetailsComponent implements OnInit {
  constructor(
    protected service: PersonalDetailsService,
    private userAccount: UserAccountFacade,
    public globalMessageService: GlobalMessageService,
    protected routingService: RoutingService,
    public translationService: TranslationService,
    public cdf: ChangeDetectorRef
  ) {}
  mapRoles: any = {
    b2bclaimraisergroup: 'Claim Raiser',
    b2badmingroup: 'Admin',
    b2bcustomergroup: 'Buyer',
  };
  role: any = [];
  userData: any;
  privacyPath: any;
  go(): void {
    this.routingService.go({
      cxRoute: 'contactUs',
    });
  }

  getRoleType(roles: string[]): string {
    return roles.length > 0
      ? roles.includes('b2badmingroup')
        ? 'Admin'
        : roles.includes('b2bclaimraisergroup')
        ? 'Claim Raiser'
        : 'Buyer'
      : '';
  }

  ngOnInit(): void {
    let path = window.location.pathname.split('/');
    let site = path[1];
    if(site === 'lipton-us'){
      this.privacyPath = "/lipton-us/en/USD/contact";
    }else{
      this.privacyPath = "/lipton-pk/en/PKR/contact";
    }
    this.translationService
      .translate('personalDetails.disclaimer',{
        path: this.privacyPath}
      )
      .subscribe((data) => {
        if (data) {
          this.globalMessageService.add(
            data ?? '',
            GlobalMessageType.MSG_TYPE_INFO,
            600000
          );
          this.cdf.detectChanges();
        }
      });
    this.userAccount.get().subscribe((response) => {
      if (response) {
        this.service.getPersonalDetails(response.uid).subscribe(
          (resp) => {
            if (resp) {
              this.userData = resp;

              let that = this;
              this.userData.roles.forEach(function (role: any) {
                that.role.push(that.mapRoles[role]);
              });
            }
          },
          () => {}
        );
      }
    });
  }
  ngOnDestroy(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
  }
}
